import * as React from 'react'
import {useContext, useEffect} from 'react'
import {useTranslation} from 'react-i18next'
import {Link} from 'react-router-dom'
import {AppContext} from '../app'
import '../css/topbar.css'
import AppProps from '../util/appProps'
import {getSignUpPath, TOPBAR_COLOR_ACCENT, TOPBAR_COLOR_AQUA, TOPBAR_COLOR_RED, getFont, updateMuliFont, localeToInternalLang} from '../util/util'
import { getCurrentLocale, locales } from '../util/locales'

const SUB_MENU_VISIBLE = 'sub-menu sub-menu-visible'
const SUB_MENU_HIDDEN = 'sub-menu sub-menu-hidden'

const TopBar = (props: AppProps) => {

    const appContext = useContext(AppContext)
    const {topbarColor, setTopbarColor} = appContext
    const {t, i18n} = useTranslation('topbar')

    let isMobile = window.innerWidth <= 1104

    const handleClick = (e) => {
        const subMenu1Button: any = document.getElementById('sub-menu-1-b')
        const subMenu2Button: any = document.getElementById('sub-menu-2-b')

        if (isMobile) {
            const menuButton: any = document.getElementById('menu-toggle')
            const menuButtonS: any = document.getElementById('menu-toggle-s')
            if (e.target != menuButton && e.target != menuButtonS) {
                menuButton.checked = e.target == subMenu1Button || e.target == subMenu2Button
            }
        } else {
            const subMenu1: any = document.getElementById('sub-menu-1')
            const subMenu2: any = document.getElementById('sub-menu-2')
            const subMenu3: any = document.getElementById('sub-menu-3')

            const subMenu3Button: any = document.getElementById('sub-menu-3-b')
            const subMenu3ButtonImg: any = document.getElementById('sub-menu-3-b-i')

            subMenu1.className = e.target == subMenu1Button ? SUB_MENU_VISIBLE : SUB_MENU_HIDDEN
            subMenu2.className = e.target == subMenu2Button ? SUB_MENU_VISIBLE : SUB_MENU_HIDDEN
            subMenu3.className = e.target == subMenu3Button || e.target == subMenu3ButtonImg ? SUB_MENU_VISIBLE : SUB_MENU_HIDDEN
        }
    }

    const handleWindowSize = () => {
        isMobile = window.innerWidth <= 1104
    }

    useEffect(() => {
        window.addEventListener('resize', handleWindowSize)
        document.onclick = handleClick
    }, [])

    const path = props.location.pathname.substring(3)
    const hash = props.location.hash

    useEffect(() => {
        switch (path) {
            case '/contact':
            case '/rtb':
                setTopbarColor(TOPBAR_COLOR_AQUA)
                break
            case '/monetization':
                setTopbarColor(TOPBAR_COLOR_RED)
                break
            default:
                setTopbarColor(TOPBAR_COLOR_ACCENT)
        }
    }, [props.location.pathname])

    const handleChangeLanguage = (lang) => {
        i18n.changeLanguage(lang)
        props.history.push('/' + lang + path + hash)
        updateMuliFont(lang)
    }

    const langImage = localeToInternalLang.get(i18n.language)?.flag

    return (
        <div className="topbar-container" style={getFont(i18n)}>
            <div className="topbar">
                <Link to={'/' + getCurrentLocale()}><img src="https://static.persona.ly/images/logo_personaly.svg" /></Link>
                <input id="menu-toggle" type="checkbox" />
                <label className="menu__btn" htmlFor="menu-toggle">
                    <span id="menu-toggle-s" />
                </label>
                <ul className={'menu ' + topbarColor.hoverColor} style={!isMobile && i18n.language.includes(locales.ru) ? {fontSize: 14} : {}}>
                    <li className="menu-i-with-sub">
                        <span id="sub-menu-1-b" >{t('programmatic')}</span>
                        <ul id="sub-menu-1" className="sub-menu sub-menu-hidden">
                            <Link to="rtb">
                                <li className={path == '/rtb' && hash != '#retargeting' ? topbarColor.linkColor : ''}>{t('ua')}</li>
                            </Link>
                            <Link to="rtb#retargeting">
                                <li className={hash == '#retargeting' ? topbarColor.linkColor : ''}>{t('retargeting')}</li>
                            </Link>
                            <a href="https://dashboard.personaly.bid" target="_blank" rel="noopener noreferrer">
                                <li>{t('dashboard')}</li>
                            </a>
                        </ul>
                    </li>
                    <li className={path == '/monetization' ? topbarColor.linkColor : ''}>
                        <Link to="monetization">{t('monetization')}</Link>
                    </li>
                    <li onClick={handleClick} className={path == '/market-research' ? topbarColor.linkColor : ''}>
                        <Link to="market-research">{t('market research')}</Link>
                    </li>
                    <li className={path == '/about' && hash != '#contact' ? topbarColor.linkColor : ''}>
                        <Link to="about">{t('about')}</Link>
                    </li>
                    <li className="menu-i-with-sub">
                        <span id="sub-menu-2-b" >{t('resources')}</span>
                        <ul id="sub-menu-2" className="sub-menu sub-menu-hidden">
                            <a href={'/blog/' + (i18n.language.includes(locales.en) ? '' : i18n.language.substring(0,2))}><li>{t('blog')}</li></a>
                            <a href="/glossary"><li>UA Glossary</li></a>
                            <Link to="rtb#case-studies">
                                <li className={hash == '#case-studies' ? topbarColor.linkColor : ''}>Case Studies</li>
                            </Link>
                            <a href="http://knowledge.persona.ly"><li>{t('knowledge base')}</li></a>
                            <Link to="context-distance-calculator">
                                <li className={path == '/context-distance-calculator' ? topbarColor.linkColor : ''}>{t('context distance calculator')}</li>
                            </Link>
                        </ul>
                    </li>
                    <li className={hash == '#contact' ? topbarColor.linkColor : ''}><Link to="about#contact">{t('contact')}</Link></li>
                    <li className="login"><Link to="login">{t('login')}</Link></li>
                    <li>
                        <Link to={getSignUpPath(path)}><button className={topbarColor.buttonColor}>{t('get started')}</button></Link>
                    </li>
                    <li className="not-mobile not-tablet">
                        <img id="sub-menu-3-b-i" src={langImage || 'https://static.persona.ly/images/usa.svg'} />
                        <span id="sub-menu-3-b" />
                        <ul id="sub-menu-3" className="sub-menu sub-menu-hidden">
                            <li onClick={() => handleChangeLanguage(locales.en)}>
                                <img alt="" src="https://static.persona.ly/images/usa.svg" /><p>{t('english')}</p>
                            </li>
                            <li onClick={() => handleChangeLanguage(locales.zh)}>
                                <img alt="" src="https://static.persona.ly/images/china.svg" /><p>{t('chinese')}</p>
                            </li>
                            <li onClick={() => handleChangeLanguage(locales.ja)}>
                                <img alt="" src="https://static.persona.ly/images/japan.svg" /><p>{t('japanese')}</p>
                            </li>
                            <li onClick={() => handleChangeLanguage(locales.ko)}>
                                <img alt="" src="https://static.persona.ly/images/korea.svg" /><p>{t('korean')}</p>
                            </li>
                            <li onClick={() => handleChangeLanguage(locales.ru)}>
                                <img alt="" src="https://static.persona.ly/images/russia.svg" /><p>{t('russian')}</p>
                            </li>
                            <li onClick={() => handleChangeLanguage(locales.id)}>
                                <img alt="" src="https://static.persona.ly/images/indonesia.svg" /><p>{t('indonesian')}</p>
                            </li>
                        </ul>
                    </li>
                    <li className="sub-menu-mobile">
                        <ul className="sub-menu sub-menu-hidden">
                            <li onClick={() => handleChangeLanguage(locales.en)}>{t('en')}</li>
                            <li>/</li>
                            <li onClick={() => handleChangeLanguage(locales.zh)}>{t('chi')}</li>
                            <li>/</li>
                            <li onClick={() => handleChangeLanguage(locales.ja)}>{t('jp')}</li>
                            <li>/</li>
                            <li onClick={() => handleChangeLanguage(locales.ko)}>{t('kor')}</li>
                            <li>/</li>
                            <li onClick={() => handleChangeLanguage(locales.ru)}>{t('ru')}</li>
                            <li>/</li>
                            <li onClick={() => handleChangeLanguage(locales.id)}>{t('id')}</li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default TopBar


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/topbar.tsx